module.exports = {
  ...require('authHeaders'),
  ...require('jsonHeaders'),
}
